import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ArticleListing from '../../reusable/Articles/ArticleListing';
import entitiesApi from './../../api/Entities.api';
import api from './TrendingEntities.api';
import headerActions from './../../reusable/Header/Header.actions';
import commonApi from './../../api/Common.api';
import utils from './../../utils/utilities';
import xhr from './../../utils/xhr';
import reduxStore from './../../reduxStore';

class TrendingTermsListingPage extends Component {

    constructor(props) {
        super(props);

        this.filters = JSON.parse(props.routeParams.filters);
        this.entityId = props.routeParams.entityId;
        this.riskAngle = props.routeParams.riskAngle;
        this.languages = utils.extractLanguagesFilter(reduxStore.getState().user.preferences.filters.languageFilter);
        this.state = {
            timestamp: null
        }
    }

    componentDidMount() {
        headerActions.updateHeaderContent(' ');
        entitiesApi.specific([this.entityId]).then((companies) => {
            this.setState({ entityTitle: companies[0].companyTitle });
            headerActions.updateHeaderContent(
                <FormattedMessage id='HeaderFooterNav_SubMenu_UIText_subMenu.entityPestleArticlesFromDays'
                                  values={{
                                      entityTitle: companies[0].companyTitle,
                                      pestle:      this.riskAngle.charAt(0).toUpperCase() + this.riskAngle.substr(1),
                                      daysNumber:  this.filters.noOfDays.toString()
                                  }} />,
                'termsresultstips-field?lbu=US&locale=en_US&audience=all'
            );
        })
    }

    getTimestamp() {
        commonApi.loadListingTimestamp()
            .then((timestamp)=>{
                this.setState({ timestamp });
            }).catch((error) => {
            utils.logError(error, 'CompanyArticlesPage.componentWillMount() - Error fetching timestamp:');
            xhr.handleAllErrors(error);
        });
    }

    render() {
        return <div className="trending-entities-page">
            <ArticleListing url={`/api/articles/riskEntity/${this.entityId}/${this.riskAngle}`}
                            countUrl={`/api/articles/count/riskEntity/${this.entityId}/${this.riskAngle}`}
                            urlParams={{
                                ...this.filters,
                                timestamp: this.state.timestamp,
                                languages: this.languages
                            }}
                            filters={{ pestle: this.riskAngle, entityId: this.entityId }}
                            api={api}
                            helpUrl={'termsresultstips-field?lbu=US&locale=en_US&audience=all'} />
        </div>
    }
}

export default TrendingTermsListingPage;


// WEBPACK FOOTER //
// ./src/scripts/pages/TrendingEntities/TrendingEntitiesListingPage.jsx